export default __webpack_public_path__ + "static/media/f07a7f271cc3c683dbfa1726387b179e1577717240799.dedd5fcb.webp";